
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1310Dialog extends Serenity.EntityDialog<Report_1310Row, any> {
        protected getFormKey() { return Report_1310Form.formKey; }
        protected getIdProperty() { return Report_1310Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1310Row.localTextPrefix; }
        protected getNameProperty() { return Report_1310Row.nameProperty; }
        protected getService() { return Report_1310Service.baseUrl; }
        protected getDeletePermission() { return Report_1310Row.deletePermission; }
        protected getInsertPermission() { return Report_1310Row.insertPermission; }
        protected getUpdatePermission() { return Report_1310Row.updatePermission; }

        protected form = new Report_1310Form(this.idPrefix);

    }
}